/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, pxToRem, mediaQuery, nthChildIterator} from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : EXPANDABLE SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  expandablesection: {
    maxWidth: pxToEm(900),
    boxShadow: '0px 1px 1px 0px rgb(237, 241, 250)',
    border: '1px solid rgb(236, 240, 247)',
    borderRadius: '4px',
    textAlign: 'left',
    opacity: '0',
    animationName: 'fadeInUp',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    extend: nthChildIterator(100, .2, .1),
    '& h2': {
      color: 'rgb(6, 43, 117)',
      fontWeight: 700,
      fontSize: pxToRem(16),
      lineHeight: pxToRem(24)
    },
    '& h5,h6': {
      whiteSpace: 'nowrap'
    },
    '& h4,h5,h6': {
      fontSize: pxToRem(14),
      lineHeight: pxToRem(20),
    },
    '& h4': {
      color: 'rgb(130, 149, 186)',
      fontWeight: 400,
      lineHeight: pxToRem(16)
    },
    '& h5': {
      color: 'rgb(6, 43, 117)',
      fontWeight: 500
    },
    '& h6': {
      color: 'rgb(192, 201, 220)',
      fontWeight: 400
    },
    '& .innerWrap': {
      boxSizing: 'content-box',
      backgroundColor: 'rgb(250, 251, 252)',
      borderRadius: '4px',
      margin: '0 8px',
      padding: '16px'
    },
    '& > .collapsable': {
      overflow: 'hidden',
      maxHeight: '0px',
      transition: 'max-height 0.3s'
    },
    '& .collapsable.opened': {
      maxHeight: pxToRem(2000)
    },
    '& > .footer': {
      minHeight: pxToEm(80),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 24px',
      [mediaQuery.customizeThinnest]: {
        justifyContent: 'center'
      }
    },
    '& > .controls': {
      '& .button:not(:first-child)': {
        marginLeft: '16px'
      },
      '& .button': {
        height: '32px',
        width: 'auto',
        padding: '0 16px',
        '& .text': {
          fontSize: pxToEm(14),
          fontWeight: 500,
          fontFamily: '"Work Sans", sans-serif;'
        }
      }
    },
    '& .formelement': {
      borderRadius: pxToEm(4),
      border: `${pxToEm(2)} solid rgb(238, 242, 246)`,
      background: 'rgb(250, 251, 252)',
      fontSize: pxToEm(15),
      fontWeight: 500,
      height: '48px',
      '& .textfield': {
        height: '44px'
      }
    }
  }
});
